import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AnalyticsService } from '@core/services/analytics.service';
import { AuthService } from '@core/services/auth.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EventService } from '@shared/services/event.service';
import { timer } from 'rxjs';
import { IUserActivationDto } from '../../interfaces/login.interfaces';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
@UntilDestroy()
export class ActivateAccountComponent implements OnInit {
  result = 0;
  idEvent: number | null = null;
  slug: string | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private eventService: EventService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      var userActivationDto: IUserActivationDto = { activationCode: params['code'] };
      this.idEvent = params['idEvent'];
      this.slug = params['slug'];

      this.loginService.activateUser(userActivationDto).pipe(untilDestroyed(this)).subscribe((responseBody) => {
        this.authService.authResult = responseBody.authResult;
        this.authService.userLogged = responseBody.user;
        this.result = 1;

        if (responseBody.signUpPath) {
          this.router.navigate([responseBody.signUpPath]);
        } else if (this.idEvent) {
          this.eventService.getAllViewByPk(this.idEvent, 1).pipe(untilDestroyed(this)).subscribe((event) => {
            this.slug = event.slug;
            this.initEventRedirectTime(1);
          });
        }

        this.analyticsService.trackSignUp('active');

      });
    });
  }

  private initEventRedirectTime(t = 3000): void {
    timer(t).pipe(untilDestroyed(this)).subscribe(() => {
      this.router.navigate(['/', 'eventnow', this.slug]);
    });
  }

}
